import { render, staticRenderFns } from "./DetailTicketAppDialogMasterSchool.vue?vue&type=template&id=858dd32a&scoped=true"
import script from "./DetailTicketAppDialogMasterSchool.vue?vue&type=script&lang=js"
export * from "./DetailTicketAppDialogMasterSchool.vue?vue&type=script&lang=js"
import style0 from "./DetailTicketAppDialogMasterSchool.vue?vue&type=style&index=0&id=858dd32a&lang=css"
import style1 from "./DetailTicketAppDialogMasterSchool.vue?vue&type=style&index=1&id=858dd32a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858dd32a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('858dd32a')) {
      api.createRecord('858dd32a', component.options)
    } else {
      api.reload('858dd32a', component.options)
    }
    module.hot.accept("./DetailTicketAppDialogMasterSchool.vue?vue&type=template&id=858dd32a&scoped=true", function () {
      api.rerender('858dd32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/dialog/DetailTicketAppDialogMasterSchool.vue"
export default component.exports